import React, { useState } from "react";
import "../styles/CaesarСipherhelppanel.css";
import { useGame } from "../GameContext";

const Helppanel: React.FC = () => {
  console.log("HelpPanel render");
  const { isHelpPanelOpen, setHelpPanelOpen } = useGame();
  const [showhelpPivots, setShowhelpPivots] = useState<string>("pivotTask");

  if (!isHelpPanelOpen) {
    return null;
  }

  return (
    <div className="CaesarСipher-helpPanel" id="CaesarСipher-helpPanel">
      <img
        src="/img/close.svg"
        id="CaesarСipher-closeButton"
        alt="Закрыть"
        className="CaesarСipher-closeButton"
        onClick={() => setHelpPanelOpen(false)}
      />
      <div className="CaesarСipher-helpPivots">
        <div
          className="CaesarСipher-selectPivots"
          id={showhelpPivots === "pivotTask" ? "CaesarСipher-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotTask")}
        >
          Задача
        </div>
      </div>
      {showhelpPivots === "pivotTask" && (
        <div id="CaesarСipher-commandsCards">
          <div className="CaesarСipher-helpCard">
            <div className="CaesarСipher-cardCaption">Суть игры</div>
            <div>
              <div>
                123123!!!!
              </div>
            </div>
          </div>
          <div className="CaesarСipher-helpCard">
            <div className="CaesarСipher-cardCaption">Правила игры</div>
            <div>
              <div>
                123123123!!!!
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Helppanel;
